import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 19h6a2 2 0 0 0 2 -2v-10a2 2 0 0 1 2 -2h7","key":"svg-0"}]]

const IconStrokeDynamic = createReactComponent('outline', 'stroke-dynamic', 'StrokeDynamic', __iconNode);

export default IconStrokeDynamic;